import type { ClientContextCourseLessonEntry } from '@course-authoring/shared-types';

/**
 * Applies a client-context save's tmp → server course-lesson id mappings to
 * the draft's composition entries. Without this, a client-added lesson keeps
 * its tmp id after the save that created its anchor, and the NEXT save
 * re-submits it as a new add — which the server rejects with
 * `lessonAlreadyInCourse`.
 */
export function applyCourseLessonIdMappings(
  entries: ClientContextCourseLessonEntry[],
  idMappings: Record<string, string>,
): ClientContextCourseLessonEntry[] {
  return entries.map((entry) => {
    const mapped = idMappings[entry.id];
    return mapped === undefined ? entry : { ...entry, id: mapped };
  });
}

/**
 * Rewrites the same mappings inside a serialized autosave snapshot so the
 * remapped draft still matches its saved baseline (no spurious follow-up
 * save). Ids are JSON string values, so quote-delimited replacement is exact.
 */
export function applyIdMappingsToSnapshot(
  serializedSnapshot: string,
  idMappings: Record<string, string>,
): string {
  let snapshot = serializedSnapshot;
  for (const [tmpId, realId] of Object.entries(idMappings)) {
    snapshot = snapshot.replaceAll(`"${tmpId}"`, `"${realId}"`);
  }
  return snapshot;
}
